export default __webpack_public_path__ + "static/media/NW0030.34I-42155_-25339_0.60455a4e.jpg";